import LotteryNumlotStatsContainer from "../../components/lottery/containers/LotteryNumlotStatsContainer";
import LotteryNumlotStatsTemplate from "../../components/lottery/templates/LotteryNumlotStatsTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Numbers3Stats() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="nm3" />
      <section className="min-h-screen">
        <LotteryNumlotStatsContainer lotteryKey="nm3" Template={LotteryNumlotStatsTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="nm3" />
    </>
  );
}
export default Numbers3Stats;